import { render } from "./ToolTitle.vue?vue&type=template&id=3d3714e7&scoped=true&ts=true"
import script from "./ToolTitle.vue?vue&type=script&lang=ts"
export * from "./ToolTitle.vue?vue&type=script&lang=ts"

import "./ToolTitle.vue?vue&type=style&index=0&id=3d3714e7&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3714e7"]])

export default __exports__